import { render, staticRenderFns } from "./RecipientContacts.vue?vue&type=template&id=33027eaf&scoped=true"
import script from "./RecipientContacts.vue?vue&type=script&lang=js"
export * from "./RecipientContacts.vue?vue&type=script&lang=js"
import style0 from "./ds-common.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./RecipientContacts.vue?vue&type=style&index=1&id=33027eaf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33027eaf",
  null
  
)

export default component.exports